export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7674.1b06b45f.jpg";